import styled from '@emotion/styled'

import { letterSpacing } from '../utils'

export const Overline3 = styled.p(({ theme }) => [
  {
    fontFamily: theme.typography.family.default,
    fontSize: '0.5rem',
    lineHeight: 1.5,
    fontWeight: 400,
    margin: 0,
    padding: 0,
  },
  letterSpacing(1),
])
